import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { HelmetProvider } from 'react-helmet-async'
import { router } from '@/router'
import { queryClient } from '@/lib/api/queryClient'
import { bootstrapSession, usingMockAuth } from '@/lib/auth/authClient'
import { setActiveWorldConfig } from '@gamecodex/world-config'
import { grymwyrdWorldConfig } from './world.config'
import './index.css'

// Register the active world before anything renders. The shared shell
// (rpgApi / contentAccess) reads world-specific facets + entitlement policy
// from this config; nothing else hardcodes SRD/Grymwyrd literals.
setActiveWorldConfig(grymwyrdWorldConfig)

// Restore an existing GameCodex Accounts session on load (validate the stored
// access token, else fall back to the refresh cookie). Skipped under the mock
// provider, where the persisted store is already the source of truth.
// Fire-and-forget: zustand re-renders subscribed components when it resolves.
if (!usingMockAuth) void bootstrapSession()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>,
)
